import React from 'react';

import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';

const ClientDepositSummary = ({ outstanding }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="ClientDepositSummary" className="flex-heading">
      <div className="text-tooltip">
        {t('balanceSheet.availableToUse')}
        <div className="info display-left">
          <span className="tooltip">
            <i>{t('balanceSheet.tooltipText')}</i>
          </span>
        </div>
      </div>
      <div>
        <CurrencySign value={outstanding?.cash_available} />
      </div>
      <div>
        <CurrencySign value={outstanding?.card_available} />
      </div>
      <div>
        <CurrencySign value={outstanding?.slick_pos_available} />
      </div>
      <div>
        <CurrencySign value={outstanding?.online_available} />
      </div>
      <div>
        <CurrencySign value={outstanding?.other_available} />
      </div>
      <div className="text-bold">
        <CurrencySign value={outstanding?.available} />
      </div>
      <div />
    </div>
  );
};

export default ClientDepositSummary;
